import styled from 'styled-components';

import { getColor, getSpace, getTextType, mq } from '@stylesheets/tools';
import { getGradientOutline } from '../../wishes.style';

const StyledWishDialog = styled.div`
  position: relative;

  form {
    position: relative;
  }

  .wishDialog__input {
    ${getGradientOutline()};

    input {
      position: relative;
      border: none;
      width: 100%;
      background: ${getColor('white')};
      padding: ${getSpace('xxxs')} ${getSpace('xxs')};
      ${getTextType('subline')};
      border-radius: 2px;
      text-transform: uppercase;
    }
  }

  .wishDialog__input-icon {
    position: absolute !important;
    top: -15px;
    left: -15px;
    ${getGradientOutline()};

    &:before {
      border-radius: 50%;
    }

    &-inner {
      position: relative;
      background: ${getColor('white')};
      border-radius: 50%;
      width: 24px;
      height: 24px;
      display: flex;
      justify-content: center;
      align-items: center;

      ${mq('m')} {
        width: 32px;
        height: 32px;
      }

      svg {
        width: 14px;

        ${mq('m')} {
          width: 18px;
        }
      }
    }
  }

  form {
    display: flex;
    flex-direction: column;
    gap: ${getSpace('s')};
    width: 100%;
    margin-top: ${getSpace('s')};
  }

  .wishDialog__actions {
    display: flex;
    justify-content: space-between;
    margin-top: ${getSpace('s')};
  }

  .wishDialog__prev-btn,
  .wishDialog__next-btn {
    display: flex;
    align-items: center;
    padding: ${getSpace('xxxs')} 0;
    gap: ${getSpace('xxxs')};

    > span {
      margin-bottom: 0;
    }

    &[disabled] {
      cursor: not-allowed;
    }

    svg {
      width: 16px;

      ${mq('m')} {
        width: 24px;
      }
    }
  }

  .wishDialog__error {
    color: ${getColor('red')};
  }

  .wishDialog__next-btn {
    padding: ${getSpace('xxxxs')} ${getSpace('xxs')};
    border: 2px solid ${getColor('black')};
    border-radius: 7px;

    ${mq('m')} {
      padding: ${getSpace('xxxs')} ${getSpace('xs')};
    }
  }

  .wishDialog__hint-trigger button {
    border: 2px solid ${getColor('black')};
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  .wishDialog__hint-panel {
    border: 2px solid ${getColor('darkGray')};
    background-color: ${getColor('black')};
    color: ${getColor('white')};
    box-shadow: 0 2px 4px rgba(0, 10, 20, 0.1);
    border-radius: 10px;
    box-sizing: border-box;
    width: 100%;

    ${mq('m')} {
      margin-left: -10px;
    }
  }

  .wishDialog__hint-content {
    padding: ${getSpace('xxs')} ${getSpace('xs')} ${getSpace('xs')};
  }
`;

export default StyledWishDialog;
